import { constants } from '..';

const { EARLIEST_TIMESTAMP } = constants;

/**
 * Convert a possibly empty DateRange to a TableStringFilterInput
 * @param dateRange - {@link DateRange}
 * @returns undefined if the dateRange is empty, or a {@link TableStringFilterInput} if either
 * dateRange.start or dateRange.end are a Date
 *
 */
export const dateRangeToFilterInput = (
    dateRange: MaybeEmptyDateRange,
): TableStringFilterInput => {
    const startString = dateRange?.start ? dateRange.start.toISOString() : null;
    const endString = dateRange?.end ? dateRange.end.toISOString() : null;

    const earliestPossibleStartString = new Date(
        EARLIEST_TIMESTAMP,
    ).toISOString();

    if (startString !== null && endString !== null) {
        // If we need to filter with a start and end date, we must use `between`. Providing both
        // `gt` and `lt` results in an error.l
        return {
            between: [startString, endString],
        };
    }

    if (startString !== null) {
        return {
            gt: startString,
        };
    }

    if (endString !== null) {
        return {
            lt: endString,
        };
    }

    return {
        gt: earliestPossibleStartString,
    };
};
